import { useTranslation } from "@flare/i18n";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { PrivacyDisclaimer } from "../components/privacy-disclaimer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepTitle } from "../components/step-title";
import { funnelInputsNameMap } from "../config";

import { ChoiceBoxContent } from "./components/choice-box-content";

export default function GreenCardStatus() {
  const { t } = useTranslation();
  const choices = [
    {
      label: t("FUNNEL_GREEN_CARD_STATUS_CHOICE_HAVE_INSIDE_US"),
      value: "I have a green card and live in the U.S.",
    },
    {
      label: t("FUNNEL_GREEN_CARD_STATUS_CHOICE_HAVE_OUTSIDE_US"),
      value: "I have a green card but live outside the U.S.",
    },
    {
      label: t("FUNNEL_GREEN_CARD_STATUS_CHOICE_DO_NOT_HAVE"),
      value: "I don’t have a green card",
    },
  ];

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <StepTitle>{t("FUNNEL_GREEN_CARD_STATUS_TITLE")}</StepTitle>
          <ChoiceBoxContent
            name={funnelInputsNameMap.greenCardStatus}
            choices={choices}
            required
          />
        </StepContent>
        <ActionsContainer>
          <PrivacyDisclaimer />
          <ActionButton>{t("FUNNEL_ACTION_BUTTON_NEXT")}</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
